import instance from "../utils/network";
import { PubTournament } from "./types";

export interface RunnerCompetitionDto {
  id: number;
  title: string;
  subTitle: string;
  bannerImage: string;
  sponsorImages: RunnerCompetitionImageDto[];
  posterImages: RunnerCompetitionImageDto[];
  startDate: Date;
  endDate: Date;
  tournamentIds: number[];
}

export interface RunnerCompetitionImageDto {
  id: number;
  ord: number;
  imageUrl: string;
}

export interface RunnerCompetitionResponse {
  competition: RunnerCompetitionDto;
  events: PubTournament[];
}

export function getRunnerCompetitionList(): Promise<RunnerCompetitionDto[]> {
  return instance.get(`/nest/runner-competition`);
}

export function getRunnerCompetitionMainList(): Promise<
  RunnerCompetitionDto[]
> {
  return instance.get(`/nest/runner-competition/main`);
}

export function getRunnerCompetitionPastList(
  year: number
): Promise<RunnerCompetitionDto[]> {
  return instance.get(`/nest/runner-competition/past/${year}`);
}

export function getRunnerCompetitionDetail(
  id: number
): Promise<RunnerCompetitionResponse> {
  return instance.get(`/nest/runner-competition/detail/${id}`);
}
